module.exports = __webpack_public_path__ + "static/V-Class limo-e94315b98182fe89da8010ccf2d04d53.jpg";